import React from "react"

import { Layout } from "../../Components/Layouts/Layout"
import PageTitle from "../../Components/Layouts/PageTitle"
import { SProvision } from "../../styles/styles"
import { provision } from "../../Config/Env"

function Privacy() {
  return (
    <Layout isNav={false} isFooter={true}>
      <PageTitle title={`${provision.Privacy.title}`} />
      <SProvision>
        <h1>{provision.Privacy.title}</h1>
        <div className="inner">{provision.Privacy.content}</div>
      </SProvision>
    </Layout>
  )
}

export default Privacy
